import { useEffect, useState } from 'react';
import useSWR from 'swr';

import { API_ORDERS } from 'Constants';

const useOrderStatus = order => {
  const [orderStatus, setOrderStatus] = useState({ ...order });
  const [shouldFetchOrder, setShouldFetchOrder] = useState(true);

  const { data: pollOrder = {} } = useSWR(
    order?.id ? `${ API_ORDERS }/${ order?.id }` : null,
    { refreshInterval: shouldFetchOrder ? 5000 : 0 }
  );

  useEffect(() => {
    if (order?.statusId !== undefined && order?.statusId !== 0) {
      setShouldFetchOrder(false);
    }
    setOrderStatus({ ...order });
  }, [order?.statusId]);

  useEffect(() => {
    if (pollOrder?.statusId !== undefined && pollOrder?.statusId !== 0) {
      setOrderStatus(pollOrder);
      setShouldFetchOrder(false);
    } else if (pollOrder?.statusId) {
      setOrderStatus(pollOrder);
    }
  }, [pollOrder?.statusId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetchOrder(false);
    }, 1000 * 60 * 2);

    return () => clearTimeout(timer);
  }, []);

  return orderStatus;
};

export default useOrderStatus;
